module.exports = __webpack_public_path__ + "static/merch13Back-f5c2925b9402dfd62c219804915fdff5.png";